import React from "react";
import './CTA.scss';
import { useNavigate } from "react-router";

const CTA = () => {

    const navigavte = useNavigate();

    const buttonHandler = () => {
        navigavte("/contact");
    }

    return (
        <section className="arta-cta">
            <div className="arta-container">
                <div className="arta-cta__wrapper">
                    <h3>Got a challenge in your business? We’ve got you! Let us know, and we’ll help you troubleshoot and get things back on track.</h3>
                    <button onClick={buttonHandler}>Contact Us</button>
                </div>
            </div>
        </section>
    )
}

export default CTA;